/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Logging_Bar_TechniqueInputs */

const en_us2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const pt_br2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const es_419_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const pt_pt2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const fr_fr2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const de_de2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

const it_it2_workout_logging_bar_technique = /** @type {(inputs: Workout_Logging_Bar_TechniqueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`10 kg`)
};

/**
* | output |
* | --- |
* | "10 kg" |
*
* @param {Workout_Logging_Bar_TechniqueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_logging_bar_technique = /** @type {((inputs?: Workout_Logging_Bar_TechniqueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Logging_Bar_TechniqueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_logging_bar_technique(inputs)
	if (locale === "es-419") return es_419_workout_logging_bar_technique(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_logging_bar_technique(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_logging_bar_technique(inputs)
	if (locale === "de-DE") return de_de2_workout_logging_bar_technique(inputs)
	if (locale === "it-IT") return it_it2_workout_logging_bar_technique(inputs)
	return en_us2_workout_logging_bar_technique(inputs)
});
export { workout_logging_bar_technique as "workout-logging.bar_technique" }